module.exports = __webpack_public_path__ + "img/LANG_SETTING.b4c838d2.svg";